<template>
    <tr>
        <td> {{ role.name }}</td>
        <td>
            <router-link
                v-if="$store.getters['provider/is_pass_permissons'](['api_v1_provider_role_update'])"
                :to="{name: 'edit_role', params: {identity: role.identity}}"
                class="ui basic green button">
                {{ $t('ui.general.edit') }}
            </router-link>

            <button
                v-if="$store.getters['provider/is_pass_permissons'](['api_v1_provider_role_delete'])"
                @click.prevent="delete_role()"
                class="ui basic red button">
                {{ $t('ui.general.delete') }}
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderRolesIndexItem",
    props: {
        role: Object
    },
    data: function () {
        return {
        }
    },
    computed: {
    },
    mounted: function() {
        var that = this;
    },
    methods: {
        delete_role: function() {
            var that = this;

            if (that.$store.getters['provider/is_pass_permissons'](['api_v1_provider_role_delete'])) {
                if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                    var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_role_delete).parse({
                        "identity": that.role.identity,
                    });

                    axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                        .then(function (response) {
                            if (response.data.status == "success") {
                                that.$parent.init();
                                // that.$noty.success('刪除' + that.role.name + '成功');
                                that.$noty.success(
                                    that.$t('ui.notifications.success.delete__name', {
                                        name: that.role.name
                                    })
                                );
                                that.$store.dispatch('provider/fetch_current_staff');
                                that.$store.dispatch('provider/fetch_current_staff_permissions');
                            } else {
                                console.log(response.data);
                                // that.$noty.error('無法刪除職位');
                                that.$noty.error(
                                    that.$t('ui.notifications.error.delete__name', {
                                        name: that.role.name
                                    })
                                );
                            }
                        })
                        .catch(function (error) {
                            console.log(error.response);
                            // that.$noty.error('刪除職位失敗');
                            that.$noty.error(
                                that.$t('ui.notifications.error.delete__name', {
                                    name: that.role.name
                                })
                            );
                        });
                }
            }

        },
    },

}
</script>

<style scoped lang="scss">
    .tooltip.help {
        position: absolute;
        cursor: pointer;
        top: -6px;
        right: -16px
    }
</style>
